// Planungsbereiche unter „Programm“ mit Kopf und Hinweisbalken.

import { HowTo, PageHead } from "../../ui";
import { Clocks } from "./Clocks";
import { Grid } from "./Grid";
import { Log } from "./Log";
import { Analysis, Rules } from "./RulesAnalysis";

const PAGES: Record<string, { title: string; text: string; el: () => JSX.Element }> = {
  uhren: { title: "Uhren", text: "Eine Uhr beschreibt den Ablauf einer Stunde: Musikkategorien, Jingles, Werbung, Nachrichten, feste Zeiten.", el: () => <Clocks /> },
  wochenraster: { title: "Wochenraster", text: "Welche Uhr wann läuft: die Woche mit Uhren bemalen. Speichern plant die kommende Woche neu.", el: () => <Grid /> },
  sendeplan: { title: "Sendeplan", text: "Der fertige Ablauf Titel für Titel. Er wird automatisch voraus geplant; die Engine spielt ihn ab.", el: () => <Log /> },
  regeln: { title: "Regeln", text: "Separation und Regeln entscheiden, welcher Song in einen Slot darf – und was gelockert wird, wenn nichts passt.", el: () => <Rules /> },
  analyse: { title: "Analyse", text: "Wie sauber ist der Plan, wie dreht sich die Musik, was lief wann.", el: () => <Analysis /> },
};

export const PLANNING_KEYS = [...Object.keys(PAGES), "log"];

export function PlanningPage({ which }: { which: string }) {
  // Old links (#/plan/sendeplan) lead to the Sendeplan.
  if (which === "log") {
    window.location.replace("#/plan/sendeplan");
    which = "sendeplan";
  }
  const p = PAGES[which];
  return (
    <div>
      <PageHead title={p.title} />
      <HowTo text={p.text} chapter={which === "log" ? "sendeplan" : "uhren"} />
      {p.el()}
    </div>
  );
}
